<script setup>
import TheFooter from '@/components/basic/organisms/TheFooter.vue'
import TheCheckoutSuccess from '@/components/checkout/organisms/TheCheckoutSuccess.vue'
</script>

<template>
  <TheCheckoutSuccess />
  <TheFooter />
</template>
